import React from 'react';

// Kontakt-sida enligt CHills Visuella-redesign
export const ContactPage = () => {
  return (
    <div className="bg-cv-base min-h-screen" style={{ padding: 'clamp(120px,18vw,150px) clamp(20px,5vw,32px) clamp(64px,10vw,96px)' }}>
      <div className="max-w-[1000px] mx-auto">
        <div className="text-center mb-20 flex flex-col items-center gap-[18px]">
          <span className="text-xs tracking-[0.34em] uppercase text-cv-accent">Kontakt</span>
          <h1 className="m-0 font-serif font-normal text-cv-ink" style={{ fontSize: 'clamp(34px,6vw,56px)' }}>Kontakt</h1>
          <span className="w-14 h-px bg-cv-accent" />
          <p className="m-0 text-[17px] leading-[1.7] text-cv-muted max-w-[56ch]">
            Vi tar gärna emot dina tankar och idéer. Låt oss diskutera hur vi kan förverkliga din vision tillsammans.
          </p>
        </div>

        <div className="grid" style={{ gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,320px),1fr))', gap: 'clamp(40px,6vw,72px)' }}>
          {/* Vänster: info + sociala medier */}
          <div className="flex flex-col gap-12">
            <div className="flex flex-col gap-7">
              <h2 className="m-0 font-serif font-medium text-[28px] text-cv-ink">Kontaktinformation</h2>
              <div className="flex flex-col gap-[22px]">
                <div className="flex items-center gap-[18px]">
                  <span className="w-[46px] h-[46px] border border-cv-edge2 rounded-full flex items-center justify-center font-serif italic text-[18px] text-cv-accent">C</span>
                  <span className="text-base text-cv-ink tracking-[0.06em]">Charlott Hill</span>
                </div>
                <div className="flex items-center gap-[18px]">
                  <span className="w-[46px] h-[46px] border border-cv-edge2 rounded-full flex items-center justify-center text-[15px] text-cv-accent">✆</span>
                  <a href="tel:0702565668" className="text-base text-cv-ink2 no-underline hover:text-cv-ink transition-colors">0702-56 56 68</a>
                </div>
                <div className="flex items-center gap-[18px]">
                  <span className="w-[46px] h-[46px] border border-cv-edge2 rounded-full flex items-center justify-center text-sm text-cv-accent">@</span>
                  <a href="mailto:charlott@hillservice.se" className="text-base text-cv-ink2 no-underline hover:text-cv-ink transition-colors">charlott@hillservice.se</a>
                </div>
              </div>
            </div>

            <div className="flex flex-col gap-6">
              <h2 className="m-0 font-serif font-medium text-[28px] text-cv-ink">Sociala Medier</h2>
              <div className="flex flex-col gap-3.5">
                <a href="https://www.facebook.com/profile.php?id=61568666219208" target="_blank" rel="noopener noreferrer" className="w-fit text-sm tracking-[0.16em] uppercase text-cv-muted no-underline border-b border-transparent pb-[3px] hover:text-cv-ink hover:border-cv-edge transition-colors">Facebook</a>
                <a href="https://www.instagram.com/chills_visuella/" target="_blank" rel="noopener noreferrer" className="w-fit text-sm tracking-[0.16em] uppercase text-cv-muted no-underline border-b border-transparent pb-[3px] hover:text-cv-ink hover:border-cv-edge transition-colors">Instagram</a>
              </div>
            </div>
          </div>

          {/* Höger: skicka meddelande */}
          <div className="flex flex-col gap-6">
            <h2 className="m-0 font-serif font-medium text-[28px] text-cv-ink">Skicka meddelande</h2>
            <div className="bg-cv-panel flex flex-col gap-[18px]" style={{ borderRadius: 'var(--cv-radius)', padding: 36 }}>
              <h3 className="m-0 font-normal text-[17px] text-cv-ink">Kontakta mig direkt</h3>
              <p className="m-0 text-[15px] leading-[1.7] text-cv-muted">
                Jag tar gärna emot dina frågor och funderingar. Hör av dig via e-post eller telefon så diskuterar vi hur jag kan hjälpa dig.
              </p>
              <div className="flex flex-col gap-3 mt-1.5">
                <a href="mailto:charlott@hillservice.se?subject=Kontakt från hemsidan" className="flex items-center justify-center gap-3 p-4 bg-cv-ink text-cv-base no-underline text-[13px] tracking-[0.18em] uppercase rounded-cv hover:bg-cv-ink2 transition-colors">Skicka e-post</a>
                <a href="tel:0702565668" className="flex items-center justify-center gap-3 p-4 bg-cv-base border border-cv-edge text-cv-ink no-underline text-[13px] tracking-[0.18em] uppercase rounded-cv hover:bg-cv-line transition-colors">Ring 0702-56 56 68</a>
              </div>
            </div>
            <div className="border border-cv-border flex flex-col gap-2.5" style={{ borderRadius: 'var(--cv-radius)', padding: '32px 36px' }}>
              <h3 className="m-0 font-normal text-base text-cv-ink">Öppettider för samtal</h3>
              <p className="m-0 text-[15px] leading-[1.8] text-cv-muted">
                Måndag - Fredag: 09:00 - 17:00<br />Lördag - Söndag: Efter överenskommelse
              </p>
              <p className="m-0 text-[13px] text-cv-faint">Svarar vanligtvis inom 24 timmar på vardagar</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
